import { toISOString } from "./helpers";
const FIRST_SESSION_VALUE = "1";

export const build = (clientUserId: string, domainUserInfo: any[]) => {
  // The domain user info is and "known" array more details at the
  // snowplow docs: https://git.io/fjwLt
  const [
    isFirstSession,
    domainUserId,
    cookieCreatedAt,
    visitCount,
    currentVisit,
    lastVisit,
    sessionId
  ] = domainUserInfo;

  return {
    clientUserId,
    cookieCreatedAt: toISOString(cookieCreatedAt),
    currentVisit: toISOString(currentVisit),
    domainUserId,
    isFirstSession: isFirstSession === FIRST_SESSION_VALUE,
    lastVisit: toISOString(lastVisit),
    sessionId,
    visitCount
  };
};
